import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const Setup = loadable(() => import('./Setup'), {});
export const ClipEscola = loadable(() => import('./ClipEscola'), {});
export const Proesc = loadable(() => import('./Proesc'), {});
export const Sophia = loadable(() => import('./Sophia'), {});

export * as Enotas from './Enotas';
